<template>
  <div class="el-col-24 accound-add">
    <h5 class="warp-title">{{mTitle}}账号</h5>
    <el-form :model="ruleForm" label-position="top" :rules="rules" ref="ruleForm" class="demo-ruleForm my-form-style">
      <el-form-item  prop="input" label="账号">
        <el-input
          v-model.trim="ruleForm.input"
          size="small"
          maxlength="20"
          style="width: 300px"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item class="grid" label="真实姓名">
        <el-input
          v-model.trim="input2"
          maxlength="20"
          size="small"
          clearable>
        </el-input>
      </el-form-item>
      <el-form-item prop="checkplatList" label="服务平台">
        <el-checkbox-group v-model="ruleForm.checkplatList">
          <el-checkbox v-for="item in platList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item prop="checkroleList" label="角色">
        <el-checkbox-group v-model="ruleForm.checkroleList">
          <el-checkbox v-for="item in roleList" :key="item.id" :label="item.id">{{item.roleName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item prop="checkgroupList" label="分组">
        <el-checkbox-group v-model="ruleForm.checkgroupList">
          <el-checkbox v-for="item in groupList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <div class="btn-c">
          <el-button type="primary" @click="submit()" :loading="isSubmitLoading">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addUserRole, queryGroupList, queryRoleList, editUserRoleReturn, editUserRole } from '../../../api/power/account'
export default {
  name: 'AccountAdd',
  created () {
  },
  computed: {
    platList () {
      return this.$store.state.Auth.platformList
    }
  },
  data () {
    return {
      isSubmitLoading: false,
      mState: this.$route.query.state,
      mId: this.$route.query.userId,
      mTitle: '新增',
      input2: '',
      roleList: [],
      groupList: [],
      ruleForm: {
        input: '',
        checkroleList: [],
        checkplatList: [],
        checkgroupList: []
      },
      rules: {
        input: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        checkplatList: [
          { type: 'array', required: true, message: '请至少选择一个平台', trigger: 'change' }
        ],
        checkroleList: [
          { type: 'array', required: true, message: '请至少选择一个角色', trigger: 'change' }
        ],
        checkgroupList: [
          { type: 'array', required: true, message: '请至少选择一个分组', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    submit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            nickName: this.ruleForm.input,
            realName: this.input2,
            platformList: this.ruleForm.checkplatList,
            roleList: this.ruleForm.checkroleList,
            customerGroupList: this.ruleForm.checkgroupList
          }
          this.isSubmitLoading = true
          if (this.mState) {
            params.userId = this.mId
            editUserRole(params).then(res => {
              this.isSubmitLoading = false
              let data = res.data
              if (data.resultCode === 0) {
                this.$message.success('编辑成功')
                this.$store.commit('delTab', this.$route)
                this.$router.push({name: 'Account', query: {refresh: Date.now()}})
              } else {
                this.$message.error(data.resultMessage)
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
          } else {
            addUserRole(params).then(res => {
              this.isSubmitLoading = false
              let data = res.data
              if (data.resultCode === 0) {
                let password = data.resultData.resetPwd
                this.$alert(`账号密码为：${password}，请注意保存。`, '账号创建成功！', {
                  confirmButtonText: '复制密码并关闭',
                  center: true,
                  callback: action => {
                    this.$copy(password)
                    this.$message.success('复制成功')
                    this.$store.commit('delTab', this.$route)
                    this.$router.push({name: 'Account', query: {refresh: Date.now()}})
                  }
                })
              } else {
                this.$alert(`${data.resultMessage}`, '账号创建失败', {
                  confirmButtonText: '我知道了',
                  center: true
                })
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    initData () {
      queryRoleList().then(res => {
        let data = res.data
        if (data.resultCode === 0) {
          this.roleList = data.resultData
        } else {
          this.$message.error(data.resultMessage)
        }
      })
      queryGroupList().then(res => {
        let data = res.data
        if (data.resultCode === 0) {
          this.groupList = data.resultData
        } else {
          this.$message.error(data.resultMessage)
        }
      })
    },
    chooseCheck (item) {
      let arr = []
      for (let i of item) {
        if (!i.status) arr.push(i.id)
      }
      return arr
    }
  },
  mounted () {
    if (this.mState) {
      this.mTitle = '编辑'
      let param = {
        userId: this.mId
      }
      editUserRoleReturn(param).then(res => {
        let data = res.data
        if (data.resultCode === 0) {
          let resultData = data.resultData
          // this.platList = resultData.platformList
          this.roleList = resultData.roleList
          this.groupList = resultData.customerGroupList

          this.ruleForm = {
            input: resultData.nickName,
            checkroleList: this.chooseCheck(this.roleList),
            checkgroupList: this.chooseCheck(this.groupList),
            checkplatList: this.chooseCheck(resultData.platformList)
          }
          this.input2 = resultData.realName
        }
      })
    } else {
      this.initData()
    }
  }
}
</script>
<style lang="less" scoped>
.p-title{
  font-size: 15px;
  margin: 10px 0;
}
.btn-c{
  margin-top: 20px;
}
.grid{
  // padding-top: 10px;
  .el-input{
    width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Power/Account/Add.vue